import useGetSession from './getSession';

const updateSessionInfo = () => {
	const [getSession] = useGetSession();

	const getSessionInfo = async (apiBase: string, setBookfairInfo: any) => {
		const { data, error } = await getSession(apiBase);

		if (error) {
			console.log(error);
			return false;
		} else if (data != null) {
			const info = {
				school: data.school.name,
				stfBalance: data.school.stfBalance,
				startDate: data.fair.deliveryDate,
				endDate: data.fair.pickupDate,
				id: data.fair.id,
				isFairEnded: data.isFairEnded,
				ccSales: data.sales.cc,
				ewalletSales: data.sales.ewallet,
				totalSales: data.sales.total,
				stfSales: data.sales.stf,
				taxStatus: data.school.taxStatus,
				taxRate: data.fair.taxRate,
				taxExemptSalesAllowed: data.fair.taxExemptSalesAllowed,
				maxTransactionItems: data.maxTransactionItems,
				ewalletEnabled: data.ewalletEnabled,
				chairpersonEmail: data.chairperson.email,
			};
			setBookfairInfo(info);

			if (info && info.isFairEnded === true) {
				return false;
			}
			return true;
		}

		return false;
	};
	return { getSessionInfo };
};

export default updateSessionInfo;
